var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "topbar" }, [
      _c("i", { on: { click: _vm.goHome } }),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox1" }, [
        _c(
          "div",
          {
            staticClass: "changeLangBtn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.moreLang()
              }
            }
          },
          [
            _vm._v(
              "\r\n            " +
                _vm._s(_vm.$t("language")) +
                "\r\n            "
            ),
            _c("em", { staticClass: "iconfont icon-een" }),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.changeLangBox,
                    expression: "changeLangBox"
                  }
                ],
                staticClass: "chooseLangUl"
              },
              _vm._l(_vm.langList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "chooseLangUlli",
                    on: {
                      click: function($event) {
                        _vm.setLanguage(item.id)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              })
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "changeLangBtn1",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.goLogin()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("homepage_button1")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "forget" }, [
        _c("div", { staticClass: "forgetPsd" }, [
          _vm._v(_vm._s(_vm.$t("verifyFail_title")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content content3" }, [
          _vm._v(_vm._s(_vm.$t("emailVerify_txt1")))
        ]),
        _vm._v(" "),
        _c("button", { staticClass: "signIn", on: { click: _vm.sucess } }, [
          _vm._v(_vm._s(_vm.$t("emailVerify_button")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content content2" }, [
          _vm._v(_vm._s(_vm.$t("emailVerify_txt2")))
        ]),
        _vm._v(" "),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.allMsg,
              expression: "allMsg"
            }
          ],
          staticClass: "send",
          domProps: { textContent: _vm._s(_vm.warinningText) }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMsg,
                expression: "showMsg"
              }
            ],
            staticClass: "content content1"
          },
          [_vm._v(_vm._s(_vm.$t("emailVerify_note")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a6e619d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6e619d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/unableLink.vue
// module id = null
// module chunks = 